module.exports = __webpack_public_path__ + "assets/ca3718ee1e702b5981a17bb15c4fce98.png";